import React, { Suspense, useEffect, useMemo, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { Await, useAsyncValue, useLoaderData, useLocation } from 'react-router-dom'

import NFIcon from '@components/shared/NFIcon'
import MenuItem from '@layout/MenuItem'
import { HomeLoaderResponse, PrivateStatisticsResponse } from '@pages/home/loaders/home.loader'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

const ActivityMenuItem: React.FC = () => {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const data = useLoaderData() as HomeLoaderResponse

  return (
    <MenuItem
      label={t('titles.news')}
      to="/home/activity"
      icon={<NFIcon icon="bell" className="text-xl" />}
      selected={pathname === '/home/activity'}
      className="mb-1"
      rightContent={
        <Suspense fallback={null}>
          <Await resolve={data.statistics}>
            <ActivityIndicator />
          </Await>
        </Suspense>
      }
    />
  )
}

export default ActivityMenuItem

const ActivityIndicator: React.FC = () => {
  const { t } = useTranslation()
  const value = useAsyncValue() as PrivateStatisticsResponse
  const { pathname } = useLocation()

  const [newsLastViewedTime, setNewsLastViewed] = useState(value.activity_stream_last_viewed_at)
  const [mostRecentActivityEventId] = useState(value.most_recent_activity_event_id)

  const hasNew = useMemo(() => {
    const lastAvailableTime = mostRecentActivityEventId
      ? parseInt(mostRecentActivityEventId.split('|')[0], 10)
      : null
    return lastAvailableTime && (!newsLastViewedTime || newsLastViewedTime < lastAvailableTime)
  }, [newsLastViewedTime, mostRecentActivityEventId])

  useEffect(() => {
    if (!pathname.startsWith('/home/activity')) {
      return
    }

    const now = new Date().getTime()
    if (!newsLastViewedTime || now > newsLastViewedTime) {
      http.post(ApiRoutes.activityStream.viewedPath())
      setNewsLastViewed(now)
    }
  }, [pathname])

  if (!hasNew) {
    return null
  }
  return (
    <span className="bg-primary text-white text-xxs font-semibold px-2.5 pb-0.5 rounded-lg">
      {t('listing.activityNew')}
    </span>
  )
}
